import { render, staticRenderFns } from "./TicketsStructure.vue?vue&type=template&id=56e55fbe"
import script from "./TicketsStructure.vue?vue&type=script&lang=ts"
export * from "./TicketsStructure.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports